import React, { useContext, useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { RiBuildingLine } from 'react-icons/ri'
import styles from './AllStores.module.css'
import { useNavigate } from 'react-router-dom'
import { CircleHelp, MapPin, Plus, Store } from 'lucide-react'
import AuthContext from '../../store/auth-context'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'

const AllStores = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const nav = useNavigate()
    const [allStores, setAllStores] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const getAllStores = async () => {
        setIsLoading(true)
        const getAllStoresResponse = await fetch(BASE_URL_API + "getAllStores",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
                })
            });

        if (!getAllStoresResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getAllStoresRespo = await getAllStoresResponse.json()
            if (getAllStoresRespo.status === "success") {
                setAllStores(getAllStoresRespo?.response)
            } else {
                setAllStores([])
                if (getAllStoresRespo.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
            console.log(getAllStoresRespo)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getAllStores()
    }, [])

    const pageMotion = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                duration: 0.32,
                ease: 'easeOut',
                staggerChildren: 0.08
            }
        }
    }

    const sectionMotion = {
        hidden: { opacity: 0, y: 14 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.34, ease: 'easeOut' }
        }
    }

    const cardMotion = {
        hidden: { opacity: 0, y: 14, scale: 0.99 },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: { duration: 0.3, ease: 'easeOut' }
        }
    }


    return (
        <motion.div className={styles.mainWrapper} variants={pageMotion} initial="hidden" animate="show">
            <div className={styles.mainContent}>
                <motion.div className={styles.mainHeader} variants={sectionMotion}>
                    <div className={styles.headerLeft}>
                        <span className={styles.statusPill}>Store Management</span>
                        <h1 className={styles.mainTitle}>All Stores / Locations</h1>
                        <p className={styles.subTitle}>Choose where you want to manage operations next.</p>
                    </div>
                    <div className={styles.headerActions}>
                        <button className={styles.helpChip}>
                            <CircleHelp size={15} /> Need Help?
                        </button>
                        <button className={styles.createBtn}>
                            <Plus size={15} /> Create New Store
                        </button>
                    </div>
                </motion.div>

                <motion.div className={styles.titleCard} variants={sectionMotion}>
                    <div className={styles.titleRow}>
                        <Store size={18} />
                        <h2>Choose A Location</h2>
                    </div>
                    <div className={styles.clSubTitle}>
                        Select a location to add, edit, and manage details.
                    </div>
                    <div className={styles.metaBadge}>
                        Total Active Stores: <span>{allStores?.length || 0}</span>
                    </div>
                </motion.div>

                {isLoading ? (
                    <motion.div className={styles.loadingState} variants={sectionMotion}>
                        <div className={styles.loaderDot}></div>
                        <span>Loading stores...</span>
                    </motion.div>
                ) : allStores?.length > 0 ? (
                    <motion.div className={styles.storesGrid} variants={sectionMotion}>
                        {allStores?.map((item, index) => (
                            <motion.button
                                onClick={() => {
                                    asCtx?.changeStore(item)
                                    nav(`/manage/details`)
                                }}
                                className={styles.eachStoreCard}
                                key={item?.storeIdentifier || index}
                                variants={cardMotion}
                                whileHover={{ y: -3 }}
                                whileTap={{ scale: 0.995 }}
                            >
                                <div className={styles.storeIconWrap}>
                                    <RiBuildingLine size={28} color="#5b4edc" />
                                </div>
                                <div className={styles.storeTxt}>
                                    <div className={styles.storeName}>{item?.storeName || 'Unnamed Store'}</div>
                                    <div className={styles.storeAddress}>
                                        <MapPin size={12} /> {item?.storeAddress || 'Address not available'}
                                    </div>
                                </div>
                                <div className={styles.openLabel}>Open Store</div>
                            </motion.button>
                        ))}
                    </motion.div>
                ) : (
                    <motion.div className={styles.emptyState} variants={sectionMotion}>
                        <Store size={22} />
                        <h3>No stores found</h3>
                        <p>Add your first location to start managing operations.</p>
                    </motion.div>
                )}
            </div>
        </motion.div>
    )
}

export default AllStores